// removed by extract-text-webpack-plugin
module.exports = {"padding":"_3oV-lDeHRnez4NGGoXEJKE","dropDowns":"_24D_9ct2CDfQwcxbvY_Em_","grid":"_3GHFCWl3Y9nXZMumecAwoE","innerRow":"uW0h-pvRCAfwtM1iPhUyY","addressGrid":"EyIdZ7G9d7zexajrttng6","verticalMiddle":"_42m1hr8gbleRjGUz6EFvs","buttonWrapper":"_3_p7Lp79tiSyOFSaWTpOsU","debtorBottomRow":"_1PJ7WRnsH2AEzrVLfWfAaR","publicListsWrapper":"_1U6nHpLMmFO6qR8mMFr3P","debtorLists":"gnGmcJ3xFvXKQESt3wEyM","simpleTableWrapper":"_9LNBTln7tCiLZu96PakoE","checkBoxWrapper":"i4i1x-DwMyI5-kA5nSDZv","checkedBoxWrapper":"_2B_10hKsZ8p2v1KkKy0pDl i4i1x-DwMyI5-kA5nSDZv"};


//////////////////
// WEBPACK FOOTER
// ./src/components/DebtPhaseDebtors/styles.css
// module id = 1065
// module chunks = 0